import React from "react";
import { getLocalDate } from "../utils";
import { Link } from "react-router-dom";

export default function CardSimpleClient({ item, to }) {
  return (
    <Link
      to={[to ?? "/clients/particuliers/show/", item.id].join("")}
      className="flex flex-col gap-2 border border-gray-200 pb-2  bg-white p-4 shadow-md rounded-md overflow-hidden min-w-0"
    >
      <div className="flex justify-between items-center gap-6 mb-4">
        <div className="">
          <h3 className="font-semibold text-sm">
            {item.nom} {item.prenom}{" "}
          </h3>
          <p className="text-sm text-gray-500">{item.adresse}</p>
        </div>
        <p className="text-amber-500 font-semibold text-sm">{item.contact1}</p>
      </div>
      <div className="flex items-center justify-between text-nowrap gap-6">
        <h3 className="flex items-center gap-1 text-sm capitalize">
          <svg
            className="w-4 h-4 text-gray-400"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              fillRule="evenodd"
              d="M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11.5c.07 0 .14-.007.207-.021.095.014.193.021.293.021h2a2 2 0 0 0 2-2V7a1 1 0 0 0-1-1h-1a1 1 0 1 0 0 2v11h-2V5a2 2 0 0 0-2-2H5Zm7 4a1 1 0 0 1 1-1h.5a1 1 0 1 1 0 2H13a1 1 0 0 1-1-1Zm0 3a1 1 0 0 1 1-1h.5a1 1 0 1 1 0 2H13a1 1 0 0 1-1-1Zm-6 4a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Zm0 3a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1ZM7 6a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H7Zm1 3V8h1v1H8Z"
              clipRule="evenodd"
            />
          </svg>
          {getLocalDate(new Date(item.date_naissance))}
        </h3>
        <p className="flex items-center text-xs text-gray-500">
          <svg
            className="w-6 h-6 text-amber-300"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path d="M13.849 4.22c-.684-1.626-3.014-1.626-3.698 0L8.397 8.387l-4.552.361c-1.775.14-2.495 2.331-1.142 3.477l3.468 2.937-1.06 4.392c-.413 1.713 1.472 3.067 2.992 2.149L12 19.35l3.897 2.354c1.52.918 3.405-.436 2.992-2.15l-1.06-4.39 3.468-2.938c1.353-1.146.633-3.336-1.142-3.477l-4.552-.36-1.754-4.17Z" />
          </svg>
          <span>
            {item.etoiles} étoiles ({item.achats} achats)
          </span>
        </p>
      </div>
    </Link>
  );
}
